import React,{useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { Button,Table,Container,Row,Col,Form } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faTrashAlt } from '@fortawesome/free-regular-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';

function Master_Entity_Contract(){  
    const navigate = useNavigate();

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [reqAgent,setReqAgent] = useState("0");
    const [ddReqAgentOptions,setDdReqAgentOptions] = useState([]);

    const [reqIsd,setReqIsd] = useState("0");
    const [ddReqIsdOptions,setDdReqIsdOptions] = useState([]);  

    const [reqMargin,setReqMargin] = useState("");
    const [showAddDiv,setShowAddDiv] = useState(false);

    const [contractData, setContractData] = useState([]);
    
    const [userRight,setUserRight] = useState([]);

    useEffect(()=>{
        if(onceRun){
            return;
        }else{
            Common.callApi(Common.apiEntity,[sid,'ddlistjson','A'],function(result){ 
                setDdReqAgentOptions(JSON.parse(result));
            });
            Common.callApi(Common.apiRight,[sid,'all','ENTITYCONTRACT'],function(result){
                let resp = JSON.parse(result);
                if(resp.query==="1"){
                    setUserRight(resp);
                }else{
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    },[onceRun,sid,navigate]);

    function getList(v){
        setReqAgent(v);
        if(v>0){
            Common.callApi(Common.apiEntityContract,[sid,'listjson',v],function(result){ 
                setContractData(JSON.parse(result));          
            });
            Common.callApi(Common.apiIsd,[sid,'ddlistjson'],function(result){ 
                setDdReqIsdOptions(JSON.parse(result));
            });
            setShowAddDiv(true);
        }else{
            setShowAddDiv(false);
        }        
    }

    function removeContract(v){
        Common.callApi(Common.apiEntityContract,[sid,'delcontract',reqAgent,v],function(result){ 
            getList(reqAgent);          
        });
    }

    function addContract(){
        Common.callApi(Common.apiEntityContract,[sid,'addcontract',reqAgent,reqIsd,reqMargin],function(result){ 
            getList(reqAgent);          
        });
    }
    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
                <Container fluid >
                    <Row>
                        <Col>
                            <h1>Entity Contract</h1>
                        </Col>  
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                <Form.Select 
                                    value={reqAgent}
                                    onChange={(e)=>getList(e.target.value)}  >
                                    {ddReqAgentOptions.map((res)=>
                                        <option key={res.value} value={res.value}>{res.name}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            &nbsp;
                            
                        </Col>
                        <Col>&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    {
                        showAddDiv && userRight.add==="1" ?
                        <>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Currency<span className="mandatory">*</span></Form.Label>
                                        <Form.Select 
                                            value={reqIsd}
                                            onChange={(e)=>setReqIsd(e.target.value)}  >
                                            {ddReqIsdOptions.map((res)=>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>            
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Margin</Form.Label>
                                        <Form.Control type="text" placeholder="Margin" maxLength={5} autoComplete="off"
                                            value={reqMargin} 
                                            onChange={(e)=>Common.validateDecValue(e.target.value,setReqMargin)} >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button onClick={(e)=>addContract()}>Add</Button>
                                    </Form.Group>
                                </Col>
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                        </>
                        :null
                    }
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        {userRight.edit==="1"? <th></th> :null}
                                        <th className="textCenter" >ISD</th>
                                        <th className="textCenter">Margin</th>
                                    </tr>
                                </thead>
                                <tbody id="tblBody">
                                    {contractData.map((res) => 
                                        <tr key={res.ec_isd}>
                                            {userRight.edit==="1"?
                                                <td className="textCenter" >
                                                    <span className="handCursor" onClick={()=>removeContract(res.ec_isd) } >
                                                        <div className="colorThemeBlue"><FontAwesomeIcon icon={faTrashAlt}  /></div>
                                                    </span>
                                                </td>
                                            :null
                                            }
                                            <td className="textCenter">{res.ec_isd}</td>
                                            <td className="textCenter">{res.ec_margin}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
        </>
    );
}
export default Master_Entity_Contract;